export default "__VITE_ASSET__29cb73c6__"